<script lang="ts">import { Button } from "@infinitro/button";
import { stateUi } from "@infinitro/config";
import { InfoCard } from "@infinitro/info-card";
import Icon from "./icon.svelte";
export let tab;
export let handleTabClick;
export let borderRadius;
export let notSameSize;
export let activeTab;
export let size;
export let useVariation;
export let el = undefined;
export let vertical = false;
export let align = "center";
export let autoFitText = true;
// opcionales: si querés replicar mayúsculas/minWidth/fullWidth también en el modo InfoCard
export let uppercase = true;
export let fullWidth = null;
export let fullWidthMobile = false;
export let minWidth = null;
// clases derivadas para emular el botón
$: sizeClass = size === "small" ? "h-[32px] text-[12px]" : size === "medium" ? "h-[36px] text-[14px]" : "h-[40px] text-[14px]";
$: widthClass = [
	fullWidth ? "w-full" : "",
	fullWidthMobile ? "full-width-mobile" : "",
	minWidth ? "min-w-[150px]" : ""
].join(" ");
$: textCaseClass = uppercase ? "uppercase" : "";
$: inactiveClass = tab.value !== activeTab ? "inactive-tab" : "active-tab";
$: useDefault = $stateUi.tabs.tabsStyle === "default";
$: useAlternative = $stateUi.tabs.tabsStyle === "alternative";
$: useAlternative2 = $stateUi.tabs.tabsStyle === "alternative2";
$: useAlternative4 = $stateUi.tabs.tabsStyle === "alternative4";
$: iconToUse = $stateUi.layout.useRemoteIcons === true && tab.remoteIcon ? tab.remoteIcon : tab.icon;
$: isInactive = tab.value !== activeTab;
$: computedVariant = useDefault ? "secondary" : useAlternative2 ? vertical && isInactive ? "transparent" : "primary" : "tertiary";
$: buttonVariant = tab.buttonVariant ?? computedVariant;
</script>

{#if useVariation && !useAlternative2}
	<!-- wrapper expone HTMLElement para scrollIntoView -->
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div
		class="tabcard-wrapper"
		class:disabled={tab.disabled ?? false}
		bind:this={el}
		on:click={(e) => handleTabClick(e, tab.value)}
		role="button"
		aria-pressed={tab.value === activeTab}
		tabindex="0"
	>
		<InfoCard
			width="100%"
			height="36px"
			noPadding={true}
			withoutBorder={false}
			flatBackground={true}
			{borderRadius}
			customStylesCard="display:flex; align-items:center; justify-content:center;"
		>
			<!-- contenido que emula al botón -->
			<div
				class={`tabcard-inner ${sizeClass} ${widthClass} ${textCaseClass} ${inactiveClass}`}
				class:variation-tabcard-inner={useVariation}
				class:alternative-tabcard-inner={useAlternative || useAlternative4}
				style="border-radius: var(--border-radius-button, 12px); padding-left: 0.75rem; padding-right: 0.75rem; justify-content: {align ===
				'start'
					? 'flex-start'
					: align === 'end'
						? 'flex-end'
						: 'center'};"
			>
				<Icon
					icon={iconToUse}
					inactiveTab={tab.value !== activeTab}
					activeTab={tab.value === activeTab}
				/>
				<p class="button-text">{tab.label}</p>

				{#if tab.quantity}
					<span class="quantity">{tab.quantity || 0}</span>
				{/if}
			</div>
		</InfoCard>
	</div>
{:else}
	<Button
		bind:this={el}
		text={tab.label}
		variant={buttonVariant}
		styleCustom={`border-radius: ${borderRadius}; padding-left: 0.5rem; padding-right: 0.5rem;`}
		onClick={(e) => handleTabClick(e, tab.value)}
		minWidth={false}
		icon={iconToUse}
		fullWidth={!notSameSize}
		inactiveTab={tab.value !== activeTab}
		activeTab={tab.value === activeTab}
		id={tab.id || tab.value.toString()}
		{size}
		{autoFitText}
		showBackgroundImage={false}
		isVerticalTab={vertical}
		{align}
		disabled={tab.disabled ?? false}
	>
		<div slot="right-slot">
			{#if tab.quantity}
				<span class="quantity">{tab.quantity || 0}</span>
			{/if}
		</div>
	</Button>
{/if}

<style>
	.tabcard-wrapper {
		width: 100%;
		cursor: pointer;
		transition-property: all;
		transition-duration: 300ms;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

	.tabcard-inner {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		border-top-width: 0.5px;
		border-color: var(--color-secondary-700);
		background-color: var(--color-secondary-500);
}

	.variation-tabcard-inner {
		border-style: none;
		border-radius: 0 !important;
}

	.alternative-tabcard-inner {
		background-color: var(--color-primary-500);
}

	.button-text {
		margin: 0px;
		display: flex;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
}

	.quantity {
		margin-left: 0.5rem;
		display: flex;
		height: 1rem;
		min-width: 1rem;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
		background-color: var(--color-primary-500);
		padding: 0.25rem;
		font-size: 0.55rem;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

	.inactive-tab {
		border-style: none;
		--tw-text-opacity: 1;
		color: rgb(209 213 219 / var(--tw-text-opacity, 1));
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
		background-color: transparent !important;
		background-image: none !important;
}
	.inactive-tab:hover {
		background-color: rgba(255, 255, 255, 0.05) !important;
	}

	@media (max-width: 1023px) {
		.full-width-mobile {
			width: 100% !important;
		}
	}

	.disabled {
		pointer-events: none;
		cursor: not-allowed;
}
</style>
